import { render, staticRenderFns } from "./fooddelivery.vue?vue&type=template&id=2d452c6a&"
import script from "./fooddelivery.vue?vue&type=script&lang=js&"
export * from "./fooddelivery.vue?vue&type=script&lang=js&"
import style0 from "./fooddelivery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports